<template>
  <div
    class="flex min-h-[100vh] w-full overflow-y-auto scrollbar-thin scrollbar-thumb-rounded-full selection:bg-metallic-violet selection:text-white"
    :class="{
      'dark:scrollbar-track-main-theme-dark dark:scrollbar-thumb-main-theme-dark-sec': isDefaultBg,
      'dark:scrollbar-track-main-theme-dark-alt dark:scrollbar-thumb-main-theme-dark-alt-sec': isRoyalDarkBg,
      'dark:scrollbar-track-main-theme-black dark:scrollbar-thumb-main-theme-black-sec': isMidnightBg,
    }"
  >
    <div class="relative flex-1" :class="background">
      <header>
        <TheIcon :display="true" classes="cursor-pointer w-16 md:w-24" />
      </header>
      <main class="md:container dark:text-white md:mx-auto">
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useThemeStore } from "~/store/themeStore";

const store = useThemeStore();

const { background, isDefaultBg, isRoyalDarkBg, isMidnightBg } = storeToRefs(store);
</script>
